import { jsxs as i, jsx as t, Fragment as T } from "react/jsx-runtime";
import { PenLine as ee, Check as oe, X as $, Loader2 as ie, Plus as se, Minus as Ge, CalendarIcon as He, Frown as $e, Trash2 as K, CloudUpload as le, Info as _, MapPin as te, ExternalLink as ce, ArrowLeft as Ke, EyeOff as Ye, Eye as Je, AlertCircle as Qe, ChevronsUpDown as Ze, CheckIcon as Xe, ChevronUp as et, ChevronDown as tt, LoaderCircle as rt, Search as nt, FileText as de, ShieldCheck as at, CheckCircle as ot, Clock as it, UserCheck as st, Mail as lt, ArrowUpDown as ct } from "lucide-react";
import { useTranslation as g } from "react-i18next";
import { Link as W } from "react-router";
import { buttonVariants as Y, Button as S, cn as f, Tooltip as ue, TooltipTrigger as me, TooltipContent as fe, AlertDialog as pe, AlertDialogContent as he, AlertDialogHeader as ge, AlertDialogTitle as we, AlertDialogDescription as be, AlertDialogFooter as ve, AlertDialogCancel as dt, AlertDialogAction as ut, Skeleton as E, Label as P, Popover as ye, PopoverTrigger as Ne, PopoverContent as xe, Calendar as mt, Input as z, Collapsible as ft, CollapsibleTrigger as pt, CollapsibleContent as ht, Progress as gt, Command as Ee, Badge as wt, CommandList as ke, CommandGroup as Se, CommandItem as Ae, CommandInput as bt, ScrollArea as vt, CommandEmpty as yt, Checkbox as Nt, Card as Ce, CardHeader as xt, CardTitle as Et, CardContent as De, Separator as kt, TableRow as St, TableHead as At, TooltipProvider as Ct } from "@workspace/shadcn";
import * as F from "react";
import { useState as N, useEffect as M, useId as V, useCallback as U, useRef as Re, forwardRef as Dt } from "react";
import { format as B, differenceInYears as Rt } from "date-fns";
import { toast as O } from "sonner";
import { useQuery as Tt, useQueryClient as It, useMutation as Lt, useMutationState as Pt } from "@tanstack/react-query";
import { Education as Ft, APIError as J, ParseError as Ut, Unauthorized as Ot } from "@workspace/client";
import { initializeApp as jt, FirebaseError as Te } from "firebase/app";
import { onAuthStateChanged as Ie, onIdTokenChanged as Le, signInWithEmailAndPassword as _t, AuthErrorCodes as k, createUserWithEmailAndPassword as Mt, updateProfile as zt, signOut as qt } from "firebase/auth";
import { useDropzone as Pe } from "react-dropzone";
import { maxBytesFor as Fe, UPLOAD_ACCEPT as Ue, parseScheduleTime as Wt, isAcceptedUploadMime as Vt } from "@workspace/isomorphic";
import { Command as Bt } from "cmdk";
import * as Oe from "react-phone-number-input";
import Gt from "react-phone-number-input/flags";
import { NumberField as Ht, Label as $t, Group as Kt, Input as Yt, Button as re } from "react-aria-components";
import { useDebounce as Jt } from "@reactuses/core";
import { flexRender as Qt } from "@tanstack/react-table";
import { z as Zt } from "zod";
import { enUS as Xt, ar as je } from "date-fns/locale";
import er from "i18next";
const Jr = {
  shared: {
    terms: {
      title: "الموافقة على الاتفاقيات والشروط",
      description: "لمتابعة استخدام المنصة، يرجى الاطلاع على المستندات التالية والموافقة عليها:",
      acknowledgement: "أقر بأنني قرأت {{documents}} وأوافق على جميع بنودهما",
      documentSeparator: " و",
      accept: "أوافق وأتابع",
      accepting: "جارٍ الحفظ...",
      logout: "تسجيل الخروج"
    },
    reviewRequest: {
      governmentSector: "قطاع حكومي",
      privateSector: "قطاع خاص",
      projectType: "نوع المشروع",
      projectLocation: "موقع المشروع",
      requestDate: "تاريخ الطلب",
      dailyWorkHours: "ساعات العمل اليومية",
      requiredServices: "الخدمات المطلوبة",
      siteConditions: "حالة الموقع",
      isolatedArea: "منطقة معزولة/منطقة نائية",
      housingTransport: "مسكن و مواصلات",
      mealsForStaff: "طعام لطاقم العمل",
      offerAndPayment: "العرض والدفع",
      proposalDeadline: "الموعد النهائي للعرض",
      bankGuarantee: "ضمان بنكي",
      paymentSystem: "نظام الدفع",
      installment: "الدفعة",
      kpis: "مؤشرات الأداء (KPIs)",
      notes: "ملاحظات"
    },
    services: {
      mobileClinic: "عيادة متنقلة",
      paramedics: "المسعفين",
      nurses: "الممرضين",
      doctors: "الأطباء",
      medicalEquipment: "المعدات الطبية",
      specialist: "أخصائي",
      technician: "فني"
    },
    offerStatus: {
      open: "متاح لاستقبال العروض",
      awaitingDocuments: "في انتظار مستندات المورد",
      awaitingReview: "في انتظار مراجعة الإدارة",
      documentsRejected: "تم رفض المستندات",
      awaitingSigning: "في انتظار توقيع العقد",
      contractReady: "تم إتمام العقد",
      awaitingTT: "في انتظار رفع إثبات الدفع",
      awaitingTTReview: "في انتظار مراجعة إثبات الدفع",
      ttRejected: "تم رفض إثبات الدفع",
      inProgress: "جاري تنفيذ الخدمة"
    },
    offerAction: {
      allDocsUploadedAwaitingReview: "تم رفع جميع المستندات - في انتظار مراجعة الإدارة",
      docsRequired: "مطلوب رفع مستندات",
      docsUploaded: "{{uploaded}} من {{total}} مستندات مرفوعة",
      uploadDocs: "رفع المستندات",
      viewDocs: "عرض المستندات",
      someDocsRejected: "تم رفض بعض المستندات",
      reviewAndReupload: "يرجى مراجعة المستندات وإعادة رفعها",
      updateDocs: "تحديث المستندات",
      awaitingSigning: "في انتظار توقيع العقد",
      project: "مشروع: {{name}}",
      signContract: "توقيع العقد",
      awaitingCustomerTT: "في انتظار رفع إثبات الدفع من العميل",
      willNotifyOnTT: "سيتم إشعارك عند رفع العميل لإثبات الدفع",
      awaitingTTReview: "في انتظار مراجعة إثبات الدفع",
      ttUnderReview: "جاري مراجعة إثبات الدفع من قبل الإدارة",
      ttRejected: "تم رفض إثبات الدفع",
      awaitingCustomerReupload: "في انتظار إعادة رفع إثبات الدفع من العميل",
      serviceInProgress: "جاري تنفيذ الخدمة",
      rejectionReason: "سبب الرفض: {{reason}}"
    },
    contract: {
      signatureStatus: "حالة التوقيع",
      signed: "تم التوقيع",
      awaitingSignature: "في انتظار التوقيع",
      signingEmailSent: "تم إرسال العقد للتوقيع إلكترونياً",
      signingEmailInstruction: "يرجى التحقق من بريدك الإلكتروني والتوقيع على العقد من خلال الرابط المرسل."
    },
    banners: {
      congratsDocsApproved: "تهانينا! تمت الموافقة على جميع المستندات المطلوبة.",
      proceedToSign: "الآن يمكنك الانتقال لتوقيع العقد.",
      project: "مشروع: {{name}}",
      signContract: "توقيع العقد",
      completeVerification: "لإكمال التحقق من حسابك، يرجى تزويدنا بمزيد من مستندات",
      submitAdditionalDocs: "تقديم مستندات إضافية",
      completeProfile: "أكمل بيانات ملفك الشخصي (المفوض بالتوقيع والمعلومات النظامية) لتفعيل العقود",
      completeProfileCta: "إكمال الملف",
      accountUnderReview: "حسابك قيد التدقيق لضمان أعلى مستوى من الخدمة، وسننجز ذلك خلال 24 ساعة فقط.",
      accountRejectedTitle: "طلب حسابك يحتاج إلى تعديلات",
      accountRejectedReason: "السبب: {{reason}}"
    },
    validation: {
      fieldValidationError: "خطأ في التحقق من صحة البيانات",
      formValidationError: "خطأ في التحقق من صحة النموذج",
      unexpectedError: "حدث خطأ غير متوقع",
      valueAlreadyInUse: "القيمة المدخلة مستخدمة بالفعل"
    },
    errors: {
      recordNotFound: "البيانات المطلوبة غير موجودة",
      validationFailed: "البيانات المدخلة غير صحيحة",
      forbidden: "غير مصرح لك بالوصول",
      unexpectedErrorRetry: "حدث خطأ غير متوقع، يرجى المحاولة لاحقًا",
      offerAlreadyAccepted: "تم قبول عرض آخر بالفعل لهذا الطلب"
    },
    payment: {
      monthly: "دفعات شهرية",
      deliverables: "دفعات المخرجات"
    },
    common: {
      notSpecified: "لم يتم التحديد",
      back: "رجوع",
      view: "عرض",
      download: "تحميل",
      loading: "جاري التحميل...",
      unavailable: "غير متاح",
      searchCountry: "ابحث عن دولة...",
      fileViewFailed: "فشل عرض الملف",
      fileDownloadFailed: "فشل تحميل الملف",
      dragFile: "ادرج الملف",
      cancel: "إلغاء",
      confirm: "تأكيد",
      mandatory: "إلزامي"
    },
    fileErrors: {
      invalidType: "نوع الملف غير مدعوم",
      tooLarge: "حجم الملف كبير جداً. الحد الأقصى المسموح 10 ميجابايت",
      tooSmall: "حجم الملف صغير جداً",
      tooMany: "عدد كبير من الملفات. يُسمح بملف واحد فقط",
      required: "هذا الحقل مطلوب. يرجى إرفاق المستند المطلوب",
      uploadFailed: "فشل رفع الملف. يرجى المحاولة مرة أخرى"
    },
    image: {
      choose: "أفلت صورة هنا، أو انقر للاختيار",
      hint: "PNG أو JPG أو WEBP، بحد أقصى 10 ميجابايت",
      uploading: "جاري الرفع...",
      remove: "إزالة الصورة",
      alt: "الصورة المختارة"
    },
    date: {
      pick: "اختر تاريخاً",
      clear: "مسح التاريخ"
    },
    equipment: {
      placeholder: "اسم المعدة أو اللوازم الطبية",
      quantity: "الكمية",
      addEquipment: "إضافة معدة"
    },
    actions: {
      profile: {
        accountUpdated: "تم تحديث بيانات الحساب",
        contactUpdated: "تم تحديث بيانات التواصل",
        signatoryUpdated: "تم تحديث بيانات المفوض بالتوقيع",
        documentsUpdated: "تم تحديث المستندات",
        additionalDocsSubmitted: "تم إرسال المستندات الإضافية"
      },
      offer: {
        documentUploaded: "تم رفع المستند",
        documentDeleted: "تم حذف المستند",
        vendorTtUploaded: "تم رفع إثبات الدفع للمورد",
        vendorTtDeleted: "تم حذف إثبات الدفع للمورد",
        vendorTtApproved: "تم اعتماد إثبات الدفع",
        vendorTtRejected: "تم رفض إثبات الدفع"
      },
      draft: {
        deleted: "تم حذف المسودة"
      }
    },
    firebase: {
      invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      tooManyAttempts: "تم حظر تسجيل الدخول بسبب محاولات متكررة، يرجى المحاولة لاحقاً",
      accountDisabled: "تم تعطيل الحساب، يرجى التواصل مع الدعم الفني",
      networkFailed: "فشل الاتصال بالشبكة، يرجى التحقق من اتصالك بالإنترنت",
      loginNotSupported: "تسجيل الدخول بالبريد الإلكتروني وكلمة المرور غير مدعوم حالياً",
      invalidEmail: "البريد الإلكتروني غير صحيح، يرجى المحاولة مرة أخرى",
      invalidPassword: "كلمة المرور غير صحيحة، يرجى المحاولة مرة أخرى",
      loginError: "حدث خطأ أثناء تسجيل الدخول",
      logoutError: "حدث خطأ أثناء تسجيل الخروج",
      emailNotRegistered: "البريد الإلكتروني غير مسجل",
      notAuthorized: "بيانات الدخول صحيحة، لكن هذا الحساب لا يملك صلاحية الوصول إلى هذه البوابة",
      resetEmailError: "حدث خطأ أثناء إرسال رابط إعادة التعيين",
      emailAlreadyInUse: "البريد الإلكتروني مسجل بالفعل",
      weakPassword: "كلمة المرور ضعيفة. الرجاء اختيار كلمة مرور أقوى",
      signupError: "حدث خطأ أثناء إنشاء الحساب"
    }
  }
}, Qr = {
  shared: {
    terms: {
      title: "Agreement and policy acceptance",
      description: "To continue using the platform, please review and accept the following documents:",
      acknowledgement: "I acknowledge that I have read the {{documents}} and agree to all their terms.",
      documentSeparator: " and ",
      accept: "Agree and continue",
      accepting: "Saving...",
      logout: "Log out"
    },
    reviewRequest: {
      governmentSector: "Government Sector",
      privateSector: "Private Sector",
      projectType: "Project Type",
      projectLocation: "Project Location",
      requestDate: "Request Date",
      dailyWorkHours: "Daily Working Hours",
      requiredServices: "Required Services",
      siteConditions: "Site Conditions",
      isolatedArea: "Isolated/Remote Area",
      housingTransport: "Housing & Transportation",
      mealsForStaff: "Meals for Staff",
      offerAndPayment: "Offer & Payment",
      proposalDeadline: "Proposal Deadline",
      bankGuarantee: "Bank Guarantee",
      paymentSystem: "Payment System",
      installment: "Installment",
      kpis: "Performance Indicators (KPIs)",
      notes: "Notes"
    },
    services: {
      mobileClinic: "Mobile Clinic",
      paramedics: "Paramedics",
      nurses: "Nurses",
      doctors: "Doctors",
      medicalEquipment: "Medical Equipment",
      specialist: "Specialist",
      technician: "Technician"
    },
    offerStatus: {
      open: "Open for Offers",
      awaitingDocuments: "Awaiting Vendor Documents",
      awaitingReview: "Awaiting Admin Review",
      documentsRejected: "Documents Rejected",
      awaitingSigning: "Awaiting Contract Signature",
      contractReady: "Contract Completed",
      awaitingTT: "Awaiting Payment Proof Upload",
      awaitingTTReview: "Awaiting Payment Proof Review",
      ttRejected: "Payment Proof Rejected",
      inProgress: "Service In Progress"
    },
    offerAction: {
      allDocsUploadedAwaitingReview: "All documents uploaded - Awaiting admin review",
      docsRequired: "Document upload required",
      docsUploaded: "{{uploaded}} of {{total}} documents uploaded",
      uploadDocs: "Upload Documents",
      viewDocs: "View Documents",
      someDocsRejected: "Some documents were rejected",
      reviewAndReupload: "Please review and re-upload the documents",
      updateDocs: "Update Documents",
      awaitingSigning: "Awaiting contract signature",
      project: "Project: {{name}}",
      signContract: "Sign Contract",
      awaitingCustomerTT: "Awaiting payment proof upload from customer",
      willNotifyOnTT: "You will be notified when the customer uploads payment proof",
      awaitingTTReview: "Awaiting payment proof review",
      ttUnderReview: "Payment proof is being reviewed by admin",
      ttRejected: "Payment proof rejected",
      awaitingCustomerReupload: "Awaiting payment proof re-upload from customer",
      serviceInProgress: "Service in progress",
      rejectionReason: "Rejection reason: {{reason}}"
    },
    contract: {
      signatureStatus: "Signature Status",
      signed: "Signed",
      awaitingSignature: "Awaiting Signature",
      signingEmailSent: "The contract has been sent for electronic signature",
      signingEmailInstruction: "Please check your email to complete the signing process"
    },
    banners: {
      congratsDocsApproved: "Congratulations! All required documents have been approved.",
      proceedToSign: "You can now proceed to sign the contract.",
      project: "Project: {{name}}",
      signContract: "Sign Contract",
      completeVerification: "To complete your account verification, please provide us with more documents",
      submitAdditionalDocs: "Submit Additional Documents",
      completeProfile: "Complete your profile (signatory and legal details) to enable contracts",
      completeProfileCta: "Complete profile",
      accountUnderReview: "Your account is under review to ensure the highest level of service. This will be completed within 24 hours.",
      accountRejectedTitle: "Your application needs changes",
      accountRejectedReason: "Reason: {{reason}}"
    },
    validation: {
      fieldValidationError: "Field validation error",
      formValidationError: "Form validation error",
      unexpectedError: "An unexpected error occurred",
      valueAlreadyInUse: "This value is already in use"
    },
    errors: {
      recordNotFound: "The requested data was not found",
      validationFailed: "The entered data is invalid",
      forbidden: "You are not authorized to access this",
      unexpectedErrorRetry: "An unexpected error occurred, please try again later",
      offerAlreadyAccepted: "Another offer has already been accepted for this request"
    },
    payment: {
      monthly: "Monthly Payments",
      deliverables: "Deliverables Payments"
    },
    common: {
      notSpecified: "Not specified",
      back: "Back",
      view: "View",
      download: "Download",
      loading: "Loading...",
      unavailable: "Unavailable",
      searchCountry: "Search for a country...",
      fileViewFailed: "File view failed",
      fileDownloadFailed: "File download failed",
      dragFile: "Drag file here",
      cancel: "Cancel",
      confirm: "Confirm",
      mandatory: "Mandatory"
    },
    fileErrors: {
      invalidType: "File type not supported",
      tooLarge: "File size is too large. Maximum allowed is 10 MB",
      tooSmall: "File size is too small",
      tooMany: "Too many files. Only one file is allowed",
      required: "This field is required. Please attach the requested file",
      uploadFailed: "Upload failed. Please try again"
    },
    image: {
      choose: "Drop an image here, or click to choose",
      hint: "PNG, JPG or WEBP, up to 10 MB",
      uploading: "Uploading...",
      remove: "Remove image",
      alt: "Selected image"
    },
    date: {
      pick: "Pick a date",
      clear: "Clear date"
    },
    equipment: {
      placeholder: "Equipment or medical supplies name",
      quantity: "Quantity",
      addEquipment: "Add Equipment"
    },
    actions: {
      profile: {
        accountUpdated: "Account info updated",
        contactUpdated: "Contact info updated",
        signatoryUpdated: "Signatory info updated",
        documentsUpdated: "Documents updated",
        additionalDocsSubmitted: "Additional documents submitted"
      },
      offer: {
        documentUploaded: "Document uploaded",
        documentDeleted: "Document deleted",
        vendorTtUploaded: "Vendor payment proof uploaded",
        vendorTtDeleted: "Vendor payment proof deleted",
        vendorTtApproved: "Payment proof approved",
        vendorTtRejected: "Payment proof rejected"
      },
      draft: {
        deleted: "Draft deleted"
      }
    },
    firebase: {
      invalidCredentials: "Invalid email or password",
      tooManyAttempts: "Login blocked due to repeated attempts, please try again later",
      accountDisabled: "Account has been disabled, please contact support",
      networkFailed: "Network connection failed, please check your internet connection",
      loginNotSupported: "Email and password login is not currently supported",
      invalidEmail: "Invalid email, please try again",
      invalidPassword: "Invalid password, please try again",
      loginError: "An error occurred during login",
      logoutError: "An error occurred during logout",
      emailNotRegistered: "Email is not registered",
      notAuthorized: "Your credentials are correct, but this account does not have access to this portal",
      resetEmailError: "An error occurred while sending the reset link",
      emailAlreadyInUse: "Email is already registered",
      weakPassword: "Weak password. Please choose a stronger password",
      signupError: "An error occurred while creating the account"
    }
  }
};
function Zr({
  projectName: e,
  linkUrl: r,
  subtitle: n
}) {
  const { t: a } = g();
  return /* @__PURE__ */ i("div", { className: "flex items-center justify-between rounded-xl border border-blue-200 bg-blue-50 py-3 ps-7 pe-4", children: [
    /* @__PURE__ */ i("div", { className: "flex-1", children: [
      /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ t(ee, { size: 20, className: "text-blue-600" }),
        /* @__PURE__ */ t("p", { className: "text-sm font-medium text-blue-800", children: a("shared.banners.congratsDocsApproved") })
      ] }),
      /* @__PURE__ */ i("div", { className: "mt-1 ms-7 text-sm text-blue-700", children: [
        /* @__PURE__ */ t("span", { children: a("shared.banners.proceedToSign") }),
        /* @__PURE__ */ i("span", { className: "ms-2", children: [
          "• ",
          a("shared.banners.project", { name: e })
        ] }),
        n && /* @__PURE__ */ i("span", { className: "ms-2", children: [
          "• ",
          n
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i(
      W,
      {
        to: r,
        className: Y({
          variant: "link",
          className: "bg-blue-600 text-sm text-white hover:bg-blue-700"
        }),
        children: [
          /* @__PURE__ */ t(ee, { size: 16, className: "me-1" }),
          a("shared.banners.signContract")
        ]
      }
    )
  ] });
}
function Xr({
  value: e,
  label: r
}) {
  return /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
    e ? /* @__PURE__ */ t(oe, { className: "text-primary shrink-0", strokeWidth: 4 }) : /* @__PURE__ */ t($, { size: 20, className: "shrink-0 text-red-500", strokeWidth: 4 }),
    /* @__PURE__ */ t("span", { children: r })
  ] });
}
function tr(e, r) {
  const n = !!e, [a, o] = N(!1);
  return M(() => {
    if (!n)
      return;
    const s = setTimeout(() => {
      o(!0);
    }, r);
    return () => {
      clearTimeout(s), queueMicrotask(() => o(!1));
    };
  }, [n, r]), n && a;
}
function rr(e) {
  return typeof e == "function" ? !0 : typeof e == "object" && e !== null && "$$typeof" in e && typeof e.render == "function";
}
function _e({ icon: e }) {
  return rr(e) ? /* @__PURE__ */ t(e, { className: "size-4" }) : /* @__PURE__ */ t(T, { children: e });
}
function Me() {
  return /* @__PURE__ */ t(ie, { className: "size-4 animate-spin" });
}
function nr({
  icon: e,
  showSpinner: r
}) {
  return /* @__PURE__ */ i("div", { className: "relative size-4 overflow-hidden", children: [
    e && /* @__PURE__ */ t(
      "div",
      {
        className: f(
          "absolute inset-0 flex items-center justify-center transition-all duration-300 ease-in-out",
          r ? "-translate-x-full opacity-0" : "translate-x-0 opacity-100"
        ),
        children: /* @__PURE__ */ t(_e, { icon: e })
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: f(
          "absolute inset-0 transition-all duration-300 ease-in-out",
          r ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        ),
        children: /* @__PURE__ */ t(Me, {})
      }
    )
  ] });
}
function ar({
  icon: e,
  showSpinner: r,
  children: n
}) {
  return /* @__PURE__ */ i(T, { children: [
    e && /* @__PURE__ */ t(
      "div",
      {
        className: f(
          "overflow-hidden transition-all duration-300 ease-in-out",
          r ? "w-0 opacity-0" : "w-4 opacity-100"
        ),
        children: /* @__PURE__ */ t(_e, { icon: e })
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: f(
          "overflow-hidden transition-all duration-300 ease-in-out",
          r ? "w-4 opacity-100" : "-ms-2 w-0 opacity-0",
          e ? "-ms-2" : ""
        ),
        children: /* @__PURE__ */ t(Me, {})
      }
    ),
    n
  ] });
}
function or({
  tooltip: e,
  children: r
}) {
  return e ? /* @__PURE__ */ i(ue, { children: [
    /* @__PURE__ */ t(me, { asChild: !0, children: r }),
    /* @__PURE__ */ t(fe, { children: e })
  ] }) : /* @__PURE__ */ t(T, { children: r });
}
function G({
  loading: e,
  disabled: r,
  children: n,
  delay: a = 300,
  icon: o,
  tooltip: s,
  size: l,
  ...d
}) {
  const u = tr(e, a), c = l?.startsWith("icon");
  return /* @__PURE__ */ t(or, { tooltip: s, children: /* @__PURE__ */ t(
    S,
    {
      disabled: r || e,
      size: l,
      ...d,
      className: f("cursor-pointer gap-2", d.className),
      children: c ? /* @__PURE__ */ t(nr, { icon: o, showSpinner: u }) : /* @__PURE__ */ t(ar, { icon: o, showSpinner: u, children: n })
    }
  ) });
}
function en({
  open: e,
  onOpenChange: r,
  mutation: n,
  title: a,
  description: o,
  actionLabel: s,
  pendingLabel: l,
  variant: d = "destructive"
}) {
  const { t: u } = g(), c = s ?? u("shared.common.confirm"), m = l ?? `${c}...`, p = (w) => {
    w.preventDefault(), n.mutate();
  };
  return /* @__PURE__ */ t(
    pe,
    {
      open: e,
      onOpenChange: (w) => {
        n.isPending || r(w);
      },
      children: /* @__PURE__ */ i(he, { children: [
        /* @__PURE__ */ i(ge, { children: [
          /* @__PURE__ */ t(we, { children: a }),
          /* @__PURE__ */ t(be, { children: o })
        ] }),
        /* @__PURE__ */ i(ve, { children: [
          /* @__PURE__ */ t(dt, { disabled: n.isPending, children: u("shared.common.cancel") }),
          /* @__PURE__ */ t(ut, { asChild: !0, children: /* @__PURE__ */ t(
            G,
            {
              type: "button",
              onClick: p,
              className: d === "destructive" ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : void 0,
              loading: n.isPending,
              children: n.isPending ? m : c
            }
          ) })
        ] })
      ] })
    }
  );
}
function tn() {
  return /* @__PURE__ */ i("div", { className: "space-y-6", children: [
    /* @__PURE__ */ t(E, { className: "h-8 w-32" }),
    /* @__PURE__ */ t(E, { className: "h-10 w-64" }),
    /* @__PURE__ */ t(E, { className: "h-5 w-48" }),
    /* @__PURE__ */ i("div", { className: "space-y-4 rounded-lg border p-4", children: [
      /* @__PURE__ */ t(E, { className: "h-6 w-32" }),
      /* @__PURE__ */ t(E, { className: "h-10 w-full" })
    ] }),
    /* @__PURE__ */ i("div", { className: "space-y-4 rounded-lg border p-4", children: [
      /* @__PURE__ */ t(E, { className: "h-6 w-32" }),
      /* @__PURE__ */ t(E, { className: "h-16 w-full" }),
      /* @__PURE__ */ t(E, { className: "h-16 w-full" })
    ] }),
    /* @__PURE__ */ i("div", { className: "space-y-4 rounded-lg border p-4", children: [
      /* @__PURE__ */ t(E, { className: "h-6 w-32" }),
      /* @__PURE__ */ t(E, { className: "h-10 w-full" }),
      /* @__PURE__ */ t(E, { className: "h-10 w-full" }),
      /* @__PURE__ */ t(E, { className: "h-10 w-full" }),
      /* @__PURE__ */ t(E, { className: "h-12 w-full" })
    ] })
  ] });
}
function ir({
  label: e,
  className: r,
  value: n,
  onChange: a,
  min: o = 0
}) {
  const s = V();
  return /* @__PURE__ */ i(
    "div",
    {
      className: f(
        "bg-background flex h-11 justify-between rounded-lg px-4",
        r
      ),
      children: [
        /* @__PURE__ */ t(P, { htmlFor: s, children: e }),
        /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ t(
            S,
            {
              onClick: () => a?.(n + 1),
              type: "button",
              variant: "outline",
              className: "h-8 min-w-8 rounded-full px-0",
              children: /* @__PURE__ */ t(se, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ t("p", { className: "mx-4 w-4 border-none bg-transparent text-center", children: n }),
          /* @__PURE__ */ t(
            S,
            {
              onClick: () => a(Math.max(o, n - 1)),
              type: "button",
              variant: "outline",
              className: "h-8 min-w-8 rounded-full px-0",
              disabled: n <= o,
              children: /* @__PURE__ */ t(Ge, { className: "h-4 w-4" })
            }
          )
        ] })
      ]
    }
  );
}
function sr(e) {
  return new Date(
    Date.UTC(e.getFullYear(), e.getMonth(), e.getDate())
  ).toISOString();
}
function ne(e) {
  if (!e) return;
  const r = new Date(e);
  return Number.isNaN(r.getTime()) ? void 0 : new Date(
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  );
}
function rn({
  label: e,
  id: r,
  value: n,
  onChange: a,
  minDate: o,
  placeholder: s,
  yearsBack: l = 1,
  yearsForward: d = 5
}) {
  const { t: u } = g(), [c, m] = N(!1), p = ne(n), w = ne(o ?? null), A = /* @__PURE__ */ new Date(), D = new Date(A.getFullYear() - l, 0, 1), C = new Date(A.getFullYear() + d, 11, 31);
  return /* @__PURE__ */ i("div", { className: "space-y-2", children: [
    e && /* @__PURE__ */ t(P, { htmlFor: r, children: e }),
    /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ i(ye, { open: c, onOpenChange: m, children: [
        /* @__PURE__ */ t(Ne, { asChild: !0, children: /* @__PURE__ */ i(
          S,
          {
            id: r,
            type: "button",
            variant: "outline",
            className: f(
              "w-full justify-start font-normal",
              !p && "text-muted-foreground"
            ),
            children: [
              /* @__PURE__ */ t(He, { className: "me-2 size-4" }),
              p ? B(p, "PPP") : s ?? u("shared.date.pick")
            ]
          }
        ) }),
        /* @__PURE__ */ t(xe, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ t(
          mt,
          {
            mode: "single",
            autoFocus: !0,
            captionLayout: "dropdown",
            startMonth: D,
            endMonth: C,
            defaultMonth: p ?? w,
            selected: p,
            disabled: w ? { before: w } : void 0,
            onSelect: (h) => {
              a(h ? sr(h) : null), m(!1);
            }
          }
        ) })
      ] }),
      p && /* @__PURE__ */ t(
        S,
        {
          type: "button",
          variant: "ghost",
          size: "icon",
          "aria-label": u("shared.date.clear"),
          onClick: () => a(null),
          children: /* @__PURE__ */ t($, { className: "size-4" })
        }
      )
    ] })
  ] });
}
const lr = new URL("https://education-api-xptd3c3dgq-wx.a.run.app"), Q = lr.origin, L = new Ft({
  baseUrl: Q
});
function nn(e, r, n) {
  return Tt({
    queryKey: [e, JSON.stringify(r)],
    ...n,
    meta: { endpoint: e, input: r },
    queryFn: () => L.request(e, r ?? {})
  });
}
function an(e, r) {
  const n = It();
  return Lt({
    ...r,
    mutationKey: [e],
    mutationFn: async (a, o) => r && "mutationFn" in r && r.mutationFn ? r.mutationFn(
      (s) => L.request(e, s),
      o
    ) : await L.request(e, a),
    onSuccess: async (a, o, s, l) => {
      for (const d of r?.invalidate ?? [])
        await n.invalidateQueries({
          predicate(u) {
            return u.meta?.endpoint === d;
          }
        });
      return r?.onSuccess?.(a, o, a, l);
    }
  });
}
function on(e) {
  return Pt({
    filters: {
      predicate(r) {
        return r.meta?.endpoint === e;
      }
    }
  });
}
async function cr(e, r, n) {
  const a = await ze(e, r), o = URL.createObjectURL(a), s = document.createElement("a");
  s.href = o, s.download = n, document.body.appendChild(s), s.click(), document.body.removeChild(s), URL.revokeObjectURL(o);
}
async function dr(e, r) {
  const n = qe();
  if (!n)
    throw new Error("Failed to open generated file");
  try {
    const a = await ze(e, r), o = URL.createObjectURL(a);
    n.location.href = o, window.setTimeout(() => URL.revokeObjectURL(o), 6e4);
  } catch (a) {
    throw n.close(), a;
  }
}
async function ze(e, r) {
  const n = await L.defaultHeaders();
  let a = e.replace("GET ", "");
  for (const [s, l] of Object.entries(r))
    a = a.replace(`{${s}}`, String(l));
  const o = await fetch(`${L.options.baseUrl}${a}`, {
    headers: n
  });
  if (!o.ok)
    throw new Error(`Failed to download file: ${o.statusText}`);
  return o.blob();
}
function qe() {
  const e = window.open("about:blank", "_blank");
  return e && (e.opener = null), e;
}
function sn({
  endpoint: e,
  input: r,
  icon: n,
  label: a,
  variant: o = "outline",
  className: s = "text-foreground",
  ...l
}) {
  const [d, u] = N(!1), { t: c } = g();
  return /* @__PURE__ */ t(
    G,
    {
      ...l,
      variant: o,
      className: s,
      loading: d,
      icon: n,
      onClick: async () => {
        u(!0);
        try {
          await dr(e, r);
        } catch {
          O.error(c("shared.common.fileViewFailed"));
        } finally {
          u(!1);
        }
      },
      children: a ?? c("shared.common.view")
    }
  );
}
function ln({
  endpoint: e,
  input: r,
  filename: n,
  icon: a,
  label: o,
  variant: s = "outline",
  className: l = "text-foreground",
  ...d
}) {
  const [u, c] = N(!1), { t: m } = g();
  return /* @__PURE__ */ t(
    G,
    {
      ...d,
      variant: s,
      className: l,
      loading: u,
      icon: a,
      onClick: async () => {
        c(!0);
        try {
          await cr(e, r, n);
        } catch {
          O.error(m("shared.common.fileDownloadFailed"));
        } finally {
          c(!1);
        }
      },
      children: o ?? m("shared.common.download")
    }
  );
}
function cn(e) {
  return /* @__PURE__ */ t(We, { ...e, purpose: "view" });
}
function dn(e) {
  return /* @__PURE__ */ t(We, { ...e, purpose: "download" });
}
function We({
  fileId: e,
  unavailableLabel: r,
  label: n,
  purpose: a,
  variant: o = "outline",
  size: s = "sm",
  ...l
}) {
  const [d, u] = N(!1), { t: c } = g();
  if (!e)
    return /* @__PURE__ */ t("span", { className: "text-muted-foreground text-sm", "aria-disabled": !0, children: r ?? c("shared.common.unavailable") });
  const m = a === "view";
  return /* @__PURE__ */ t(
    G,
    {
      ...l,
      variant: o,
      size: s,
      loading: d,
      onClick: async () => {
        u(!0);
        const p = qe();
        if (!p) {
          O.error(
            c(
              m ? "shared.common.fileViewFailed" : "shared.common.fileDownloadFailed"
            )
          ), u(!1);
          return;
        }
        try {
          const { signedUrl: w } = await L.request("GET /files/{id}/access", {
            id: e,
            purpose: a
          });
          p.location.href = w;
        } catch {
          p.close(), O.error(
            c(
              m ? "shared.common.fileViewFailed" : "shared.common.fileDownloadFailed"
            )
          );
        } finally {
          u(!1);
        }
      },
      children: n ?? c(m ? "shared.common.view" : "shared.common.download")
    }
  );
}
function un({
  className: e,
  type: r,
  ...n
}) {
  return /* @__PURE__ */ t(
    z,
    {
      id: "email",
      type: "email",
      dir: "ltr",
      placeholder: "me@example.com",
      ...n
    }
  );
}
function mn(e) {
  return /* @__PURE__ */ i(T, { children: [
    /* @__PURE__ */ t("p", { className: "mt-8 mb-7 font-medium", children: e.title }),
    /* @__PURE__ */ i("div", { className: "flex h-80 flex-col items-center justify-center space-y-4 rounded-lg border text-center", children: [
      /* @__PURE__ */ t($e, { size: 32 }),
      /* @__PURE__ */ i("div", { children: [
        /* @__PURE__ */ t("p", { className: "text-xl font-bold", children: e.subtitle }),
        /* @__PURE__ */ t("p", { className: "", children: e.description })
      ] })
    ] })
  ] });
}
function fn(e) {
  return Array.isArray(e) ? e.reduce(
    (r, n) => r + (n.quantity || 0),
    0
  ) : 0;
}
function pn({
  label: e,
  value: r,
  onChange: n
}) {
  const { t: a } = g();
  return /* @__PURE__ */ i(T, { children: [
    e && /* @__PURE__ */ t(P, { className: "text-muted-foreground text-sm", children: e }),
    r.map((o, s) => /* @__PURE__ */ i(
      "div",
      {
        className: "flex items-start gap-2 rounded-lg border p-3",
        children: [
          /* @__PURE__ */ i("div", { className: "flex-1 space-y-3", children: [
            /* @__PURE__ */ t(
              z,
              {
                placeholder: a("shared.equipment.placeholder"),
                value: o.name,
                onChange: (l) => {
                  const d = [...r];
                  d[s] = { ...o, name: l.target.value }, n(d);
                }
              }
            ),
            /* @__PURE__ */ t(
              ir,
              {
                label: a("shared.equipment.quantity"),
                value: o.quantity,
                min: 1,
                onChange: (l) => {
                  const d = [...r];
                  d[s] = { ...o, quantity: l }, n(d);
                }
              }
            )
          ] }),
          /* @__PURE__ */ t(
            S,
            {
              type: "button",
              variant: "ghost",
              size: "icon",
              className: "text-destructive hover:text-destructive/80 shrink-0",
              onClick: () => n(r.filter((l, d) => d !== s)),
              children: /* @__PURE__ */ t(K, { className: "h-4 w-4" })
            }
          )
        ]
      },
      s
    )),
    /* @__PURE__ */ i(
      S,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        className: "w-full",
        onClick: () => n([...r, { name: "", quantity: 1 }]),
        children: [
          /* @__PURE__ */ t(se, { className: "h-4 w-4" }),
          a("shared.equipment.addEquipment")
        ]
      }
    )
  ] });
}
function hn({
  title: e,
  subtitle: r,
  children: n,
  className: a,
  defaultOpen: o,
  onOpenChange: s
}) {
  const [l, d] = F.useState(o ?? !1);
  return /* @__PURE__ */ i(
    ft,
    {
      onOpenChange: (c) => {
        d(c), s?.(c);
      },
      open: l,
      className: f(
        "dark:bg-input/30 border-input w-full min-w-0 rounded-md border bg-transparent px-3 text-base transition-[color] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        r ? "data-[state=closed]:h-15" : "data-[state=closed]:h-11",
        a,
        l ? "" : "flex items-center"
      ),
      children: [
        /* @__PURE__ */ t(pt, { className: "!h-auto min-h-full w-full", children: /* @__PURE__ */ i(
          "div",
          {
            className: f(
              "my-3 flex h-full items-center gap-2 [[data-state=open]]:my-3"
            ),
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  className: f(
                    "size-4 rounded-full py-px text-white",
                    l ? "bg-primary" : "border"
                  ),
                  children: l ? /* @__PURE__ */ t(oe, { size: 15 }) : /* @__PURE__ */ t(T, {})
                }
              ),
              /* @__PURE__ */ i("div", { children: [
                /* @__PURE__ */ t(P, { htmlFor: e, children: e }),
                r && /* @__PURE__ */ t("p", { className: "text-muted-foreground text-xs", children: r })
              ] })
            ]
          }
        ) }),
        /* @__PURE__ */ t(ht, { children: n })
      ]
    }
  );
}
function gn(e) {
  const r = V(), { t: n } = g(), a = e.errors.filter((o) => !!o).map((o) => n(o.message));
  return a.length === 0 ? null : /* @__PURE__ */ t(
    "p",
    {
      "data-slot": "form-message",
      id: r,
      className: f("text-destructive text-sm", e.className),
      children: a.join(",")
    }
  );
}
function wn(e) {
  const r = V(), { t: n } = g(), a = Array.from(
    new Set(
      e.errors.filter((o) => !!o).flatMap((o) => o.form?.map((s) => n(s.message)) ?? [])
    )
  );
  return a.length === 0 ? null : /* @__PURE__ */ t(
    "ul",
    {
      "data-slot": "form-message",
      id: r,
      className: "text-destructive list-disc ps-5 text-sm",
      children: a.map((o) => /* @__PURE__ */ t("li", { children: o }, o))
    }
  );
}
const H = {
  "api/record-not-found": "shared.errors.recordNotFound",
  "api/validation-failed": "shared.errors.validationFailed",
  "api/forbidden": "shared.errors.forbidden",
  "offers/request-already-accepted": "shared.errors.offerAlreadyAccepted"
};
function j(e) {
  return { form: [{ message: e }] };
}
function ur(e) {
  if (e instanceof J) {
    const r = e.data;
    if (r.cause.code === "api/validation-failed")
      return {
        form: Object.entries(r.cause.errors).map(([n, a]) => ({
          message: a.map((o) => o.message).join(",")
        }))
      };
    if (r.cause.code === "api/unique-constraint-failed") {
      const n = r.cause.fields || [], a = {};
      for (const o of n)
        a[o] = [
          { message: "shared.validation.valueAlreadyInUse" }
        ];
      return n.length === 0 ? j("shared.validation.valueAlreadyInUse") : a;
    }
    return j(H[r.cause.code] || r.cause.detail);
  }
  if (e instanceof Ut) {
    const r = {};
    return e.data.fieldErrors && (Array.isArray(e.data.fieldErrors) ? r.form = e.data.fieldErrors.map((n) => ({
      message: n.message || "shared.validation.fieldValidationError"
    })) : Object.entries(e.data.fieldErrors).forEach(([n, a]) => {
      a && a.length > 0 && (r[n] = a.map((o) => ({
        message: o.message || "shared.validation.fieldValidationError"
      })));
    })), e.data.formErrors && Array.isArray(e.data.formErrors) && e.data.formErrors.length > 0 && (r.form = e.data.formErrors.map((n) => ({
      message: n.message || "shared.validation.formValidationError"
    }))), Object.keys(r).length === 0 ? j("shared.validation.fieldValidationError") : r;
  }
  return e instanceof Error ? j(e.message) : j("shared.validation.unexpectedError");
}
function bn(e) {
  const r = "shared.errors.unexpectedErrorRetry";
  if (e instanceof J) {
    const n = e.data, a = n.cause?.code;
    if (a && H[a]) return H[a];
    if (n.cause?.detail) return n.cause.detail;
    if (n.error) return n.error;
  }
  return e instanceof Error && e.message ? e.message : r;
}
const v = {
  INVALID_CREDENTIALS: "shared.firebase.invalidCredentials",
  TOO_MANY_ATTEMPTS: "shared.firebase.tooManyAttempts",
  ACCOUNT_DISABLED: "shared.firebase.accountDisabled",
  NETWORK_FAILED: "shared.firebase.networkFailed",
  LOGIN_NOT_SUPPORTED: "shared.firebase.loginNotSupported",
  INVALID_EMAIL: "shared.firebase.invalidEmail",
  INVALID_PASSWORD: "shared.firebase.invalidPassword",
  LOGIN_ERROR: "shared.firebase.loginError",
  LOGOUT_ERROR: "shared.firebase.logoutError",
  EMAIL_NOT_REGISTERED: "shared.firebase.emailNotRegistered",
  NOT_AUTHORIZED: "shared.firebase.notAuthorized",
  RESET_EMAIL_ERROR: "shared.firebase.resetEmailError",
  EMAIL_ALREADY_IN_USE: "shared.firebase.emailAlreadyInUse",
  WEAK_PASSWORD: "shared.firebase.weakPassword",
  SIGNUP_ERROR: "shared.firebase.signupError"
}, vn = jt(
  JSON.parse('{"apiKey":"AIzaSyAFkV8xx7b7VxvqK59zMxYbOe1GTK_U9EU","appId":"1:698102571057:web:587f672b665289f0b3f510","authDomain":"education-portal-505105.firebaseapp.com","messagingSenderId":"698102571057","projectId":"education-portal-505105","storageBucket":"education-portal-505105.firebasestorage.app"}')
);
function yn(e) {
  return new Promise((r) => {
    const n = [], a = (o) => {
      console.log({ subject: o }), r(o || null), n.forEach((s) => s());
    };
    n.push(Ie(e, a)), n.push(Le(e, a));
  });
}
function Nn(e) {
  const [r, n] = N(e.currentUser), a = U((o) => {
    n(o || null);
  }, []);
  return M(() => Ie(e, a), [a, e]), M(() => Le(e, a), [a, e]), r;
}
async function xn(e, r, n) {
  if (e.currentUser)
    return {
      user: e.currentUser,
      token: await e.currentUser.getIdToken()
    };
  try {
    const o = (await _t(e, r, n)).user, s = await o.getIdToken();
    return { subject: o, token: s };
  } catch (a) {
    if (a instanceof Te)
      switch (a.code) {
        case k.INVALID_IDP_RESPONSE:
        case k.INVALID_LOGIN_CREDENTIALS:
          throw new Error(v.INVALID_CREDENTIALS);
        case k.TOO_MANY_ATTEMPTS_TRY_LATER:
          throw new Error(v.TOO_MANY_ATTEMPTS);
        case k.USER_DISABLED:
          throw new Error(v.ACCOUNT_DISABLED);
        case k.USER_DELETED:
          throw new Error(v.EMAIL_NOT_REGISTERED);
        case k.NETWORK_REQUEST_FAILED:
          throw new Error(v.NETWORK_FAILED);
        case k.OPERATION_NOT_ALLOWED:
          throw new Error(v.LOGIN_NOT_SUPPORTED);
        case k.INVALID_EMAIL:
          throw new Error(v.INVALID_EMAIL);
        case k.INVALID_PASSWORD:
          throw new Error(v.INVALID_PASSWORD);
        default:
          throw new Error(v.LOGIN_ERROR);
      }
    throw a instanceof J && a.status === 403 ? (await mr(e).catch(() => {
    }), new Error(v.NOT_AUTHORIZED)) : a;
  }
}
async function En(e, r) {
  try {
    if (!(await fetch(`${Q}/auth/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: r })
    })).ok)
      throw new Error(v.RESET_EMAIL_ERROR);
  } catch (n) {
    throw n instanceof Error && n.message.startsWith("shared.") ? n : new Error(v.RESET_EMAIL_ERROR);
  }
}
async function kn(e) {
  try {
    await fetch(`${Q}/auth/password-changed`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: e })
    });
  } catch (r) {
    console.error("Failed to notify password-changed", r);
  }
}
async function Sn(e, r, n, a) {
  try {
    const s = (await Mt(e, r, n)).user, l = await s.getIdToken();
    return await zt(s, { displayName: a }), { subject: s, token: l };
  } catch (o) {
    if (o instanceof Te)
      switch (o.code) {
        case k.EMAIL_EXISTS:
          throw new Error(v.EMAIL_ALREADY_IN_USE);
        case k.WEAK_PASSWORD:
          throw new Error(v.WEAK_PASSWORD);
        case k.INVALID_EMAIL:
          throw new Error(v.INVALID_EMAIL);
        case k.NETWORK_REQUEST_FAILED:
          throw new Error(v.NETWORK_FAILED);
        default:
          throw new Error(v.SIGNUP_ERROR);
      }
    throw o;
  }
}
async function mr(e) {
  try {
    await qt(e);
  } catch (r) {
    throw console.error("Error during logout:", r), new Error(v.LOGOUT_ERROR);
  }
}
function An({
  children: e,
  className: r
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: f(
        "bg-primary text-primary-foreground relative min-h-40 w-full overflow-hidden rounded-xl",
        r
      ),
      children: [
        /* @__PURE__ */ t("div", { className: "absolute top-1/2 -left-1/4 h-full w-1/2 rounded-full bg-black/5" }),
        /* @__PURE__ */ t("div", { className: "px-14 py-8", children: e }),
        /* @__PURE__ */ t("div", { className: "absolute -top-1/4 left-3/4 h-full w-1/2 rounded-full bg-black/5" })
      ]
    }
  );
}
async function fr(e, r = {}) {
  const { fileId: n, sessionUri: a, chunkSize: o } = await L.request(
    "POST /signed-url",
    {
      name: e.name,
      type: e.type,
      size: e.size,
      public: r.public ?? !1
    }
  ), s = e.size;
  let l = 0;
  for (; l < s; ) {
    const d = Math.min(l + o, s), u = d === s, c = await pr({
      sessionUri: a,
      chunk: e.slice(l, d),
      start: l,
      end: d,
      total: s,
      signal: r.signal
    });
    if (u) {
      if (!c.ok)
        throw new Error(`Final chunk failed: ${c.status}`);
      r.onProgress?.(s, s);
      break;
    }
    if (c.status !== 308)
      throw new Error(`Unexpected chunk response: ${c.status}`);
    l = hr(c.headers.get("Range")), r.onProgress?.(l, s);
  }
  return n;
}
async function pr(e) {
  return fetch(e.sessionUri, {
    method: "PUT",
    headers: {
      "Content-Range": `bytes ${e.start}-${e.end - 1}/${e.total}`
    },
    body: e.chunk,
    signal: e.signal
  });
}
function hr(e) {
  const r = e?.match(/bytes=0-(\d+)/);
  if (!r)
    throw new Error(
      "GCS resumable PUT returned 308 without a usable Range header — cannot determine confirmed offset"
    );
  return Number(r[1]) + 1;
}
function gr(e) {
  return `/files/${e}/raw`;
}
function Cn({
  label: e,
  value: r,
  onChange: n,
  helperText: a,
  className: o
}) {
  const { t: s } = g(), [l, d] = N(null), [u, c] = N(null), m = Re(null);
  M(() => () => m.current?.abort(), []);
  const p = U(
    async (h, b) => {
      if (b.length > 0) {
        const I = b[0].errors.some(
          (R) => R.code === "file-too-large"
        );
        d(
          s(I ? "shared.fileErrors.tooLarge" : "shared.fileErrors.invalidType")
        );
        return;
      }
      const y = h[0];
      if (!y) return;
      m.current?.abort();
      const x = new AbortController();
      m.current = x, d(null), c(0);
      try {
        const I = await fr(y, {
          public: !0,
          signal: x.signal,
          onProgress: (R, Be) => c(Math.round(R / Be * 100))
        });
        n(gr(I));
      } catch {
        x.signal.aborted || d(s("shared.fileErrors.uploadFailed"));
      } finally {
        x.signal.aborted || c(null);
      }
    },
    [n, s]
  ), { getRootProps: w, getInputProps: A, isDragActive: D } = Pe({
    onDrop: p,
    accept: Ue,
    multiple: !1,
    maxSize: Fe("image/png"),
    disabled: u !== null
  }), C = u !== null;
  return /* @__PURE__ */ i("div", { className: f("space-y-2", o), children: [
    e && /* @__PURE__ */ t(P, { children: e }),
    r && !C ? /* @__PURE__ */ i("div", { className: "relative overflow-hidden rounded-md border", children: [
      /* @__PURE__ */ t(
        "img",
        {
          src: r,
          alt: s("shared.image.alt"),
          className: "aspect-16/10 w-full object-cover"
        }
      ),
      /* @__PURE__ */ i(
        S,
        {
          type: "button",
          variant: "secondary",
          size: "sm",
          className: "absolute end-2 top-2",
          onClick: () => {
            d(null), n(null);
          },
          children: [
            /* @__PURE__ */ t(K, { className: "me-1 size-3.5" }),
            s("shared.image.remove")
          ]
        }
      )
    ] }) : /* @__PURE__ */ i(
      "div",
      {
        ...w(),
        className: f(
          "border-input flex aspect-16/10 w-full flex-col items-center justify-center gap-2 rounded-md border border-dashed px-4 text-sm transition-colors",
          !C && "hover:bg-accent hover:text-accent-foreground cursor-pointer",
          D && "border-primary bg-primary/5",
          l && "border-destructive"
        ),
        children: [
          /* @__PURE__ */ t("input", { ...A() }),
          C ? /* @__PURE__ */ i(T, { children: [
            /* @__PURE__ */ t(ie, { className: "text-muted-foreground size-5 animate-spin" }),
            /* @__PURE__ */ t("span", { className: "text-muted-foreground", children: s("shared.image.uploading") }),
            /* @__PURE__ */ t(gt, { value: u, className: "w-2/3" })
          ] }) : /* @__PURE__ */ i(T, { children: [
            /* @__PURE__ */ t(le, { className: "text-muted-foreground size-6" }),
            /* @__PURE__ */ t("span", { className: "text-muted-foreground text-center", children: s("shared.image.choose") }),
            /* @__PURE__ */ t("span", { className: "text-muted-foreground text-xs", children: a ?? s("shared.image.hint") })
          ] })
        ]
      }
    ),
    l && /* @__PURE__ */ t("p", { className: "text-destructive text-sm", children: l })
  ] });
}
function Dn() {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M22.1667 4.84155H5.83333C4.54467 4.84155 3.5 5.88622 3.5 7.17489V23.5082C3.5 24.7969 4.54467 25.8416 5.83333 25.8416H22.1667C23.4553 25.8416 24.5 24.7969 24.5 23.5082V7.17489C24.5 5.88622 23.4553 4.84155 22.1667 4.84155Z",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M18.6666 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M3.5 11.8416H24.5",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M9.33337 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M19.8334 16.5081H12.8334",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M15.1666 21.1748H8.16663",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M8.16663 16.5081H8.17788",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M19.8334 21.1748H19.8446",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function Rn() {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M14 2.50806C16.2635 2.50764 18.4782 3.16568 20.3743 4.40197C22.2703 5.63826 23.7658 7.39941 24.6785 9.47077C25.5911 11.5421 25.8815 13.8342 25.5142 16.0677C25.1469 18.3012 24.1379 20.3797 22.61 22.0497",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M14 7.1748V14.1748L18.6667 16.5081",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M2.91671 10.5291C2.54495 11.6592 2.34823 12.8395 2.33337 14.0291",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M3.30176 18.8416C3.95684 20.3487 4.92294 21.7004 6.13676 22.8082",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M5.40869 6.2823C5.73424 5.92791 6.0814 5.59399 6.44819 5.28247",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M10.0847 25.1648C12.994 26.2012 16.1956 26.0418 18.9876 24.7214",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function Tn({
  to: e,
  className: r
}) {
  const { t: n } = g();
  return /* @__PURE__ */ i(
    "div",
    {
      className: f(
        "mt-8 flex items-center justify-between rounded-xl bg-[#FEF3C7] py-3 ps-7 pe-4",
        r
      ),
      children: [
        /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ t(_, { size: 20, className: "text-[#92400E]" }),
          /* @__PURE__ */ t("p", { className: "text-sm font-medium text-[#92400E]", children: n("shared.banners.completeProfile") })
        ] }),
        /* @__PURE__ */ t(
          W,
          {
            to: e,
            className: Y({
              variant: "link",
              className: "bg-[#92400E] text-sm text-white hover:bg-[#7C3A0B]"
            }),
            children: n("shared.banners.completeProfileCta")
          }
        )
      ]
    }
  );
}
function wr({
  className: e,
  ...r
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      ...r,
      className: f(
        "flex h-1.5 w-6 flex-row items-center gap-1 rounded-full bg-white/50 px-3",
        e
      )
    }
  );
}
function In({
  className: e,
  count: r,
  value: n,
  onChange: a,
  cumulative: o = !1
}) {
  return /* @__PURE__ */ t("div", { className: f(e, "flex items-center justify-center gap-1"), children: Array.from({ length: r }).map((s, l) => /* @__PURE__ */ t(
    wr,
    {
      role: a ? "button" : void 0,
      onClick: a ? () => a(l) : void 0,
      "data-step-active": (o ? l <= n : l === n) ? "true" : "false",
      className: (o ? l <= n : l === n) ? "bg-background" : "bg-white/50"
    },
    l
  )) });
}
function Ln() {
  const { t: e } = g();
  return /* @__PURE__ */ t("div", { className: "my-16 flex h-full items-center justify-center", children: /* @__PURE__ */ i("div", { className: "flex flex-col items-center space-y-4", children: [
    /* @__PURE__ */ t("div", { className: "relative", children: /* @__PURE__ */ t("div", { className: "border-t-primary h-12 w-12 animate-spin rounded-full border-4 border-gray-200" }) }),
    /* @__PURE__ */ t("p", { className: "text-sm font-medium text-gray-600", children: e("shared.common.loading") })
  ] }) });
}
function br(e, r) {
  return `https://www.google.com/maps/search/?api=1&query=${e},${r}`;
}
function vr(e, r) {
  return !(e === 0 && r === 0);
}
function Pn({
  name: e,
  latitude: r,
  longitude: n,
  iconSize: a = 20,
  className: o,
  showMapIcon: s = !0
}) {
  const { t: l } = g();
  return vr(r, n) ? /* @__PURE__ */ i(
    "a",
    {
      href: br(r, n),
      target: "_blank",
      rel: "noopener noreferrer",
      className: f(
        "group flex items-center gap-2 hover:underline",
        o
      ),
      children: [
        s && /* @__PURE__ */ t(te, { size: a, className: "shrink-0" }),
        /* @__PURE__ */ t("span", { children: e }),
        /* @__PURE__ */ t(
          ce,
          {
            size: 14,
            className: "shrink-0 opacity-50 group-hover:opacity-100"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ i("span", { className: f("flex items-center gap-2", o), children: [
    s && /* @__PURE__ */ t(te, { size: a, className: "shrink-0" }),
    /* @__PURE__ */ t("span", { children: e || l("shared.common.notSpecified") })
  ] });
}
function Fn({
  options: e,
  selectedValues: r,
  onSelectionChange: n,
  dir: a,
  placeholder: o,
  searchPlaceholder: s = "Search...",
  emptyMessage: l = "No options found."
}) {
  const d = Re(null), [u, c] = N(!1), [m, p] = N(""), w = U(
    (h) => {
      const b = r.filter((y) => y !== h);
      n(b);
    },
    [r, n]
  ), A = U(
    (h) => {
      const b = d.current;
      if (b) {
        if ((h.key === "Delete" || h.key === "Backspace") && b.value === "") {
          const y = [...r];
          y.pop(), n(y);
        }
        h.key === "Escape" && b.blur();
      }
    },
    [r, n]
  ), D = e.filter(
    (h) => !r.includes(h.value)
  ), C = U(
    (h) => {
      p("");
      const b = [...r, h.value];
      n(b);
    },
    [r, n]
  );
  return /* @__PURE__ */ i(
    Ee,
    {
      onKeyDown: A,
      className: "overflow-visible bg-transparent",
      children: [
        /* @__PURE__ */ t("div", { className: "group border-input ring-offset-background focus-within:ring-ring rounded-md border px-3 py-2 text-sm focus-within:ring-2 focus-within:ring-offset-2", children: /* @__PURE__ */ i("div", { className: "flex flex-wrap gap-1", children: [
          r.map((h) => {
            const b = e.find((y) => y.value === h);
            return b ? /* @__PURE__ */ i(wt, { variant: "secondary", children: [
              b.label,
              /* @__PURE__ */ t(
                "button",
                {
                  className: "ring-offset-background focus:ring-ring ms-1 rounded-full outline-none focus:ring-2 focus:ring-offset-2",
                  onKeyDown: (y) => {
                    y.key === "Enter" && w(h);
                  },
                  onMouseDown: (y) => {
                    y.preventDefault(), y.stopPropagation();
                  },
                  onClick: () => w(h),
                  children: /* @__PURE__ */ t($, { className: "text-muted-foreground hover:text-foreground h-3 w-3" })
                }
              )
            ] }, h) : null;
          }),
          /* @__PURE__ */ t(
            Bt.Input,
            {
              ref: d,
              dir: a,
              value: m,
              onValueChange: p,
              onBlur: () => c(!1),
              onFocus: () => c(!0),
              placeholder: r.length === 0 ? o : s,
              className: "placeholder:text-muted-foreground ms-2 min-w-32 flex-1 bg-transparent outline-none"
            }
          )
        ] }) }),
        /* @__PURE__ */ t("div", { className: "relative mt-2", children: /* @__PURE__ */ t(ke, { dir: a, children: u && D.length > 0 ? /* @__PURE__ */ t("div", { className: "bg-popover text-popover-foreground animate-in absolute top-0 z-10 w-full rounded-md border shadow-md outline-none", children: /* @__PURE__ */ t(Se, { className: "h-full overflow-auto", children: D.map((h) => /* @__PURE__ */ t(
          Ae,
          {
            onMouseDown: (b) => {
              b.preventDefault(), b.stopPropagation();
            },
            onSelect: () => C(h),
            className: "cursor-pointer",
            children: h.label
          },
          h.value
        )) }) }) : null }) })
      ]
    }
  );
}
function Un(e) {
  return (r, n, a, o) => {
    if (console.error(r), r instanceof Ot && r.status === 401) {
      e.onUnauthorized();
      return;
    }
    if (!o.meta?.toast) return;
    const s = Object.values(ur(r)).flat().map((l) => e.i18n.t(l.message)).join(", ");
    if (s) {
      O.error(s);
      return;
    }
    O.error(r instanceof Error ? r.message : e.fallbackMessage);
  };
}
function On({
  title: e,
  children: r,
  className: n,
  showBackButton: a,
  size: o = "md"
}) {
  const { t: s } = g();
  return /* @__PURE__ */ t("div", { className: f("page-container", n), children: /* @__PURE__ */ i(
    "div",
    {
      className: f(
        "mx-auto w-full",
        o === "sm" ? "max-w-2xl" : o === "md" ? "max-w-3xl" : o === "lg" ? "max-w-4xl" : "max-w-3xl"
      ),
      children: [
        /* @__PURE__ */ i("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ t("h1", { className: "text-3xl font-bold", children: e }),
          a && /* @__PURE__ */ i(
            W,
            {
              to: "../",
              className: "text-primary flex gap-x-1 text-sm font-bold",
              children: [
                /* @__PURE__ */ t("span", { children: s("shared.common.back") }),
                /* @__PURE__ */ t(Ke, {})
              ]
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { className: "mt-8", children: r })
      ]
    }
  ) });
}
const yr = Dt(
  ({ className: e, showPasswordByDefault: r = !1, ...n }, a) => {
    const [o, s] = N(r);
    return /* @__PURE__ */ i("div", { className: "relative", children: [
      /* @__PURE__ */ t(
        z,
        {
          type: o ? "text" : "password",
          className: f("ltr:ps-10 rtl:pe-10", e),
          dir: "ltr",
          ref: a,
          ...n
        }
      ),
      /* @__PURE__ */ t(
        S,
        {
          type: "button",
          variant: "ghost",
          size: "sm",
          className: "absolute top-1/2 -translate-y-1/2 h-full px-3 py-2 hover:bg-transparent ltr:left-0 rtl:right-0",
          onClick: () => s((l) => !l),
          "aria-label": o ? "Hide password" : "Show password",
          children: o ? /* @__PURE__ */ t(Ye, { className: "text-muted-foreground h-4 w-4" }) : /* @__PURE__ */ t(Je, { className: "text-muted-foreground h-4 w-4" })
        }
      )
    ] });
  }
);
yr.displayName = "PasswordInput";
function jn() {
  const { t: e } = g();
  return /* @__PURE__ */ i("div", { className: "mt-8 flex items-center justify-between rounded-xl bg-[#D5DCFF] py-3 ps-7 pe-4", children: [
    /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ t(_, { size: 20, className: "text-black" }),
      /* @__PURE__ */ t("p", { className: "text-sm font-medium text-black", children: e("shared.banners.completeVerification") })
    ] }),
    /* @__PURE__ */ t(
      W,
      {
        to: "/additional-documents",
        className: Y({
          variant: "link",
          className: "bg-[#333E75] text-sm text-white"
        }),
        children: e("shared.banners.submitAdditionalDocs")
      }
    )
  ] });
}
function _n() {
  const { t: e } = g();
  return /* @__PURE__ */ t("div", { className: "my-8 rounded-xl bg-[#FFF6F0] px-7 py-3", children: /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ t(_, { size: 20, className: "text-[#EF7014]" }),
    /* @__PURE__ */ t("p", { className: "text-sm font-medium text-black", children: e("shared.banners.accountUnderReview") })
  ] }) });
}
function Mn({ reason: e }) {
  const { t: r } = g();
  return /* @__PURE__ */ t("div", { className: "my-8 rounded-xl border border-red-200 bg-red-50 px-7 py-4", children: /* @__PURE__ */ i("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ t(Qe, { size: 20, className: "mt-0.5 text-red-600" }),
    /* @__PURE__ */ i("div", { className: "flex-1", children: [
      /* @__PURE__ */ t("p", { className: "font-semibold text-black", children: r("shared.banners.accountRejectedTitle") }),
      e && /* @__PURE__ */ t("p", { className: "mt-1 text-sm text-black/80", children: r("shared.banners.accountRejectedReason", { reason: e }) })
    ] })
  ] }) });
}
function zn() {
  if (typeof navigator > "u") return;
  const e = navigator.language ?? "en-US";
  return new Intl.Locale(e).region;
}
const Nr = F.forwardRef(
  ({ className: e, onChange: r, value: n, ...a }, o) => /* @__PURE__ */ t(
    Oe.default,
    {
      ref: o,
      className: f("flex", e),
      flagComponent: Z,
      countrySelectComponent: xr,
      inputComponent: Ve,
      smartCaret: !1,
      value: n || void 0,
      onChange: (s) => r?.(s || ""),
      ...a
    }
  )
);
Nr.displayName = "PhoneInput";
const Ve = F.forwardRef(({ className: e, ...r }, n) => /* @__PURE__ */ t(
  z,
  {
    className: f(
      "rounded-s-none rounded-e-lg focus-visible:ring-[0px]",
      e
    ),
    ...r,
    ref: n
  }
));
Ve.displayName = "InputComponent";
const xr = ({
  disabled: e,
  value: r,
  options: n,
  onChange: a
}) => {
  const { t: o } = g(), s = F.useRef(null), [l, d] = F.useState(""), [u, c] = F.useState(!1);
  return /* @__PURE__ */ i(ye, { open: u, onOpenChange: c, modal: !0, children: [
    /* @__PURE__ */ t(Ne, { asChild: !0, children: /* @__PURE__ */ i(
      S,
      {
        type: "button",
        variant: "outline",
        dir: "ltr",
        className: "flex !min-h-12 gap-1 rounded-s-lg rounded-e-none border-r-0 bg-transparent px-3 focus:z-10",
        disabled: e,
        children: [
          /* @__PURE__ */ t(
            Z,
            {
              country: r,
              countryName: r
            }
          ),
          /* @__PURE__ */ t(
            Ze,
            {
              className: f(
                "-mr-2 size-4 opacity-50",
                e ? "hidden" : "opacity-100"
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ t(xe, { className: "w-[300px] p-0", children: /* @__PURE__ */ i(Ee, { children: [
      /* @__PURE__ */ t(
        bt,
        {
          value: l,
          onValueChange: (m) => {
            d(m), setTimeout(() => {
              if (s.current) {
                const p = s.current.querySelector(
                  "[data-radix-scroll-area-viewport]"
                );
                p && (p.scrollTop = 0);
              }
            }, 0);
          },
          placeholder: o("shared.common.searchCountry")
        }
      ),
      /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ i(vt, { ref: s, className: "h-72", children: [
        /* @__PURE__ */ t(yt, { children: "No country found." }),
        /* @__PURE__ */ t(Se, { children: n.map(
          ({ value: m, label: p }) => m ? /* @__PURE__ */ t(
            Er,
            {
              country: m,
              countryName: p,
              selectedCountry: r,
              onChange: a,
              onSelectComplete: () => c(!1)
            },
            m
          ) : null
        ) })
      ] }) })
    ] }) })
  ] });
}, Er = ({
  country: e,
  countryName: r,
  selectedCountry: n,
  onChange: a,
  onSelectComplete: o
}) => /* @__PURE__ */ i(Ae, { className: "gap-2", onSelect: () => {
  a(e), o();
}, children: [
  /* @__PURE__ */ t(Z, { country: e, countryName: r }),
  /* @__PURE__ */ t("span", { className: "flex-1 text-sm", children: r }),
  /* @__PURE__ */ t("span", { className: "text-foreground/50 text-sm", children: `+${Oe.getCountryCallingCode(e)}` }),
  /* @__PURE__ */ t(
    Xe,
    {
      className: `ml-auto size-4 ${e === n ? "opacity-100" : "opacity-0"}`
    }
  )
] }), Z = ({ country: e, countryName: r }) => {
  const n = Gt[e];
  return /* @__PURE__ */ t("span", { className: "bg-foreground/20 flex h-4 w-6 overflow-hidden rounded-sm [&_svg:not([class*='size-'])]:size-full", children: n && /* @__PURE__ */ t(n, { title: r }) });
};
function qn({
  label: e,
  value: r,
  onChange: n,
  onBlur: a,
  showCounter: o = !1
}) {
  return /* @__PURE__ */ i(
    Ht,
    {
      formatOptions: {
        style: "currency",
        currency: "SAR",
        currencySign: "accounting"
      },
      onBlur: a,
      onChange: n,
      value: r,
      children: [
        /* @__PURE__ */ t($t, { className: "text-foreground mb-4 text-sm font-medium", children: e }),
        /* @__PURE__ */ i(Kt, { className: "border-input data-[focus-within]:border-ring data-[focus-within]:ring-ring/20 relative mt-2 inline-flex h-11 w-full items-center overflow-hidden rounded-lg border text-sm whitespace-nowrap shadow-sm shadow-black/5 transition-shadow data-[disabled]:opacity-50 data-[focus-within]:ring-[3px] data-[focus-within]:outline-none", children: [
          /* @__PURE__ */ t(Yt, { className: "bg-background text-foreground flex-1 px-3 py-2 tabular-nums focus:outline-none" }),
          o && /* @__PURE__ */ i("div", { className: "flex h-[calc(100%+2px)] flex-col", children: [
            /* @__PURE__ */ t(
              re,
              {
                slot: "increment",
                className: "border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-shadow disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                children: /* @__PURE__ */ t(et, { size: 12, strokeWidth: 2, "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ t(
              re,
              {
                slot: "decrement",
                className: "border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px -mt-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-shadow disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                children: /* @__PURE__ */ t(tt, { size: 12, strokeWidth: 2, "aria-hidden": "true" })
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function Wn({
  onChange: e,
  minCharacters: r,
  ...n
}) {
  const a = V(), [o, s] = N(n.value || ""), l = Jt(o, 300), [d, u] = N(n.value);
  d !== n.value && (u(n.value), s(n.value || ""));
  const c = o.trim(), p = /^\d/.test(c) ? 0 : typeof r == "function" ? r(o) : r ?? 3;
  return M(() => {
    if (e) {
      const w = l.trim();
      w.length ? w.length >= p && e(w) : e(void 0);
    }
  }, [l, e, p]), /* @__PURE__ */ i("div", { className: f("min-w-[300px]", n.className), children: [
    /* @__PURE__ */ t(P, { htmlFor: a, children: n.label }),
    /* @__PURE__ */ i("div", { className: "relative", children: [
      /* @__PURE__ */ t(
        z,
        {
          id: a,
          className: "peer h-11 ps-9 pe-9 shadow-none",
          placeholder: n.placeholder ?? "Search...",
          value: o,
          type: "text",
          onChange: (w) => {
            s(w.target.value);
          }
        }
      ),
      /* @__PURE__ */ t("div", { className: "text-muted-foreground/80 pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 peer-disabled:opacity-50", children: n.isLoading ? /* @__PURE__ */ t(
        rt,
        {
          className: "animate-spin",
          size: 16,
          strokeWidth: 2,
          role: "status",
          "aria-label": "Loading..."
        }
      ) : /* @__PURE__ */ t(nt, { size: 16, strokeWidth: 2, "aria-hidden": "true" }) })
    ] })
  ] });
}
function kr(e) {
  return e.startsWith("ar") ? "ar-u-nu-latn" : e;
}
function Sr(e, r) {
  const { hours: n, minutes: a } = Wt(e), o = new Date(2e3, 0, 1, n, a);
  return new Intl.DateTimeFormat(r, {
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(o);
}
function q({ locale: e, value: r }) {
  return /* @__PURE__ */ t("bdi", { dir: "ltr", children: Sr(r, e) });
}
function Vn({
  from: e,
  to: r
}) {
  const { i18n: n } = g(), a = kr(n.language);
  return n.dir() === "rtl" ? /* @__PURE__ */ i("span", { className: "inline-flex items-center gap-1", children: [
    /* @__PURE__ */ t(q, { locale: a, value: e }),
    /* @__PURE__ */ t("span", { children: "-" }),
    /* @__PURE__ */ t(q, { locale: a, value: r })
  ] }) : /* @__PURE__ */ i("span", { children: [
    /* @__PURE__ */ t(q, { locale: a, value: e }),
    " -",
    " ",
    /* @__PURE__ */ t(q, { locale: a, value: r })
  ] });
}
function Bn({
  children: e,
  className: r
}) {
  return /* @__PURE__ */ t(
    "span",
    {
      className: f(
        "flex items-center gap-0.5 rounded-md border bg-white px-1.5 py-px",
        r
      ),
      children: e
    }
  );
}
function Gn({
  open: e,
  isPending: r,
  onAccept: n,
  onLogout: a,
  documents: o
}) {
  const { t: s } = g(), [l, d] = N(!1), u = o.map(({ label: c }) => c).join(s("shared.terms.documentSeparator"));
  return /* @__PURE__ */ t(pe, { open: e, children: /* @__PURE__ */ i(he, { className: "gap-7 rounded-3xl p-6 sm:max-w-3xl sm:p-10", children: [
    /* @__PURE__ */ i(ge, { children: [
      /* @__PURE__ */ t(we, { className: "text-2xl leading-tight sm:text-3xl", children: s("shared.terms.title") }),
      /* @__PURE__ */ t(be, { className: "text-base leading-7 sm:text-lg", children: s("shared.terms.description") })
    ] }),
    /* @__PURE__ */ t("ul", { className: "divide-border divide-y overflow-hidden rounded-xl border", children: o.map((c) => {
      const m = c.kind === "agreement" ? de : at;
      return /* @__PURE__ */ t("li", { children: /* @__PURE__ */ i(
        "a",
        {
          href: c.href,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "hover:bg-accent focus-visible:ring-ring flex min-h-16 items-center gap-3 px-5 py-4 text-base font-medium text-blue-600 transition-colors focus-visible:ring-2 focus-visible:outline-none sm:text-lg dark:text-blue-400",
          children: [
            /* @__PURE__ */ t(m, { "aria-hidden": "true", className: "size-6" }),
            /* @__PURE__ */ t("span", { children: c.label }),
            /* @__PURE__ */ t(
              ce,
              {
                "aria-hidden": "true",
                className: "ms-auto size-5"
              }
            )
          ]
        }
      ) }, c.href);
    }) }),
    /* @__PURE__ */ i(
      "label",
      {
        htmlFor: "terms-acceptance",
        className: "flex cursor-pointer items-start gap-3 text-base leading-8 sm:text-lg",
        children: [
          /* @__PURE__ */ t(
            Nt,
            {
              id: "terms-acceptance",
              checked: l,
              onCheckedChange: (c) => d(c === !0),
              disabled: r,
              className: "mt-1.5 size-5"
            }
          ),
          /* @__PURE__ */ t("span", { children: s("shared.terms.acknowledgement", {
            documents: u
          }) })
        ]
      }
    ),
    /* @__PURE__ */ i(ve, { className: "gap-3 sm:rtl:flex-row-reverse", children: [
      /* @__PURE__ */ t(
        S,
        {
          variant: "outline",
          onClick: a,
          disabled: r,
          className: "min-w-40",
          children: s("shared.terms.logout")
        }
      ),
      /* @__PURE__ */ t(
        S,
        {
          onClick: n,
          disabled: !l || r,
          className: "min-w-40",
          children: s(r ? "shared.terms.accepting" : "shared.terms.accept")
        }
      )
    ] })
  ] }) });
}
function Hn({
  firstSigned: e,
  secondSigned: r,
  firstLabel: n,
  secondLabel: a,
  className: o
}) {
  const { t: s } = g();
  return /* @__PURE__ */ i(Ce, { className: f("mb-6", o), children: [
    /* @__PURE__ */ t(xt, { children: /* @__PURE__ */ t(Et, { className: "text-lg", children: s("shared.contract.signatureStatus") }) }),
    /* @__PURE__ */ i(De, { className: "space-y-4", children: [
      /* @__PURE__ */ t(ae, { label: n, signed: e }),
      /* @__PURE__ */ t(kt, {}),
      /* @__PURE__ */ t(ae, { label: a, signed: r })
    ] })
  ] });
}
function ae({ label: e, signed: r }) {
  const { t: n } = g();
  return /* @__PURE__ */ i("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ i("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ t(
        "div",
        {
          className: f(
            "flex h-10 w-10 items-center justify-center rounded-full",
            r ? "bg-green-100" : "bg-gray-100"
          ),
          children: r ? /* @__PURE__ */ t(ot, { className: "h-5 w-5 text-green-600" }) : /* @__PURE__ */ t(it, { className: "h-5 w-5 text-gray-500" })
        }
      ),
      /* @__PURE__ */ i("div", { children: [
        /* @__PURE__ */ t("p", { className: "font-medium", children: e }),
        /* @__PURE__ */ t("p", { className: "text-muted-foreground text-sm", children: n(r ? "shared.contract.signed" : "shared.contract.awaitingSignature") })
      ] })
    ] }),
    r && /* @__PURE__ */ t(st, { className: "h-5 w-5 text-green-600" })
  ] });
}
function $n({
  title: e,
  description: r
} = {}) {
  const { t: n } = g();
  return /* @__PURE__ */ t(Ce, { className: "border-blue-200 bg-blue-50", children: /* @__PURE__ */ t(De, { className: "p-4", children: /* @__PURE__ */ i("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ t(lt, { className: "mt-0.5 h-5 w-5 shrink-0 text-blue-600" }),
    /* @__PURE__ */ i("div", { children: [
      /* @__PURE__ */ t("p", { className: "font-medium text-blue-800", children: e ?? n("shared.contract.signingEmailSent") }),
      /* @__PURE__ */ t("p", { className: "mt-1 text-sm text-blue-700", children: r ?? n("shared.contract.signingEmailInstruction") })
    ] })
  ] }) }) });
}
function Kn(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "62",
      height: "63",
      fill: "none",
      viewBox: "0 0 62 63",
      ...e,
      children: [
        /* @__PURE__ */ i("g", { clipPath: "url(#a)", children: [
          /* @__PURE__ */ t("circle", { cx: "31", cy: "31.5", r: "31", fill: "#E9F6ED" }),
          /* @__PURE__ */ t("g", { filter: "url(#b)", children: /* @__PURE__ */ t(
            "path",
            {
              fill: "#E9F6ED",
              fillRule: "evenodd",
              d: "M31.516 57.334c11.985 0 21.7-9.716 21.7-21.7s-9.715-21.7-21.7-21.7c-5.376 0-7.42 6.449-11.211 9.688-4.659 3.98-10.489 5.404-10.489 12.012 0 11.984 9.716 21.7 21.7 21.7",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ t(
            "path",
            {
              fill: "#fff",
              d: "M30.742 50.1c9.987 0 18.083-8.096 18.083-18.083S40.729 13.934 30.74 13.934 12.659 22.03 12.659 32.017 20.754 50.1 30.742 50.1"
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              stroke: "#239D46",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "4",
              d: "m24 32.357 4.8 5.143 11.2-12"
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: [
          /* @__PURE__ */ t("clipPath", { id: "a", children: /* @__PURE__ */ t("path", { fill: "#fff", d: "M0 .5h62v62H0z" }) }),
          /* @__PURE__ */ i(
            "filter",
            {
              id: "b",
              width: "65.4",
              height: "65.4",
              x: "-1.184",
              y: "2.934",
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ t(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ t(
                  "feGaussianBlur",
                  {
                    result: "effect1_foregroundBlur_401_19025",
                    stdDeviation: "5.5"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Yn({
  headerGroup: e
}) {
  return /* @__PURE__ */ t(St, { children: e.headers.map((r) => /* @__PURE__ */ t(At, { colSpan: r.colSpan, children: r.isPlaceholder ? null : /* @__PURE__ */ i(
    "div",
    {
      className: f(
        "flex",
        r.column.getCanSort() ? "cursor-pointer items-center select-none" : ""
      ),
      onClick: r.column.getToggleSortingHandler(),
      title: r.column.getCanSort() ? r.column.getNextSortingOrder() === "asc" ? "Sort ascending" : r.column.getNextSortingOrder() === "desc" ? "Sort descending" : "Clear sort" : void 0,
      children: [
        Qt(
          r.column.columnDef.header,
          r.getContext()
        ),
        /* @__PURE__ */ i("div", { className: "mx-2", children: [
          r.column.getCanSort() && !r.column.getIsSorted() && /* @__PURE__ */ t(ct, { className: "size-4" }),
          r.column.getIsSorted() && /* @__PURE__ */ i("span", { className: "text-xs", children: [
            "(",
            r.column.getIsSorted() === "asc" ? "↑" : "↓",
            ")"
          ] })
        ] })
      ]
    }
  ) }, r.id)) });
}
function Ar(e, r, n) {
  return {
    "file-invalid-type": n("shared.fileErrors.invalidType"),
    "file-too-large": n("shared.fileErrors.tooLarge"),
    "file-too-small": n("shared.fileErrors.tooSmall"),
    "too-many-files": n("shared.fileErrors.tooMany")
  }[e] || r;
}
function Jn({
  label: e,
  name: r,
  value: n,
  onChange: a,
  accept: o = Ue,
  maxSizeBytes: s = 10 * 1024 * 1024,
  helperText: l = "PNG, JPG / JPEG, WEBP",
  suffix: d,
  canDelete: u = !0,
  required: c = !1
}) {
  const { t: m } = g(), [p, w] = N([]), A = n ?? null, D = U(
    (x, I) => {
      if (w(I), x && x.length > 0) {
        const R = x[0];
        a?.(R);
      }
    },
    [a]
  ), { getRootProps: C, getInputProps: h, isDragActive: b } = Pe({
    onDrop: D,
    accept: o,
    multiple: !1,
    maxSize: s
  }), y = () => {
    w([]), a?.(null);
  };
  return /* @__PURE__ */ t("div", { className: "space-y-3", children: /* @__PURE__ */ i("div", { className: "space-y-2", children: [
    e && /* @__PURE__ */ i(P, { className: "text-sm font-medium", children: [
      e,
      c ? /* @__PURE__ */ t(Ct, { delayDuration: 0, children: /* @__PURE__ */ i(ue, { children: [
        /* @__PURE__ */ t(me, { asChild: !0, children: /* @__PURE__ */ t(
          "span",
          {
            tabIndex: 0,
            className: "inline-flex cursor-help",
            "aria-label": m("shared.common.mandatory"),
            children: /* @__PURE__ */ t(_, { size: 16 })
          }
        ) }),
        /* @__PURE__ */ t(fe, { children: m("shared.common.mandatory") })
      ] }) }) : /* @__PURE__ */ t(_, { size: 16 })
    ] }),
    /* @__PURE__ */ t("div", { className: "relative", children: /* @__PURE__ */ i(
      "div",
      {
        ...C(),
        className: f(
          "border-input flex h-12 w-full cursor-pointer items-center justify-between rounded-md border border-dashed px-3 py-2 text-sm transition-colors",
          "hover:bg-accent hover:text-accent-foreground",
          b && "border-primary bg-primary/5",
          p.length > 0 && "border-destructive",
          A && "border-none bg-gray-50"
        ),
        children: [
          /* @__PURE__ */ t("input", { ...h(), name: r }),
          A ? /* @__PURE__ */ i("div", { className: "flex w-full items-center gap-2", children: [
            /* @__PURE__ */ t(de, { size: 16 }),
            /* @__PURE__ */ t("span", { className: "truncate text-right", children: A.name }),
            u && /* @__PURE__ */ t(
              S,
              {
                type: "button",
                variant: "ghost",
                size: "sm",
                onClick: (x) => {
                  x.stopPropagation(), y();
                },
                className: "text-destructive hover:text-destructive/90 mr-auto h-6 shrink-0 cursor-pointer px-2",
                children: /* @__PURE__ */ t(K, { size: 14 })
              }
            ),
            d
          ] }) : /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ t(le, { className: "size-4 shrink-0" }),
            /* @__PURE__ */ i("span", { className: "text-right", children: [
              l,
              " - ",
              m("shared.common.dragFile")
            ] })
          ] })
        ]
      }
    ) }),
    p.length > 0 && /* @__PURE__ */ t("div", { className: "text-destructive text-xs", children: p.map((x, I) => /* @__PURE__ */ t("div", { children: x.errors.map((R) => Ar(R.code, R.message, m)).join(", ") }, `${x.file.name}-${I}`)) })
  ] }) });
}
const Qn = Zt.instanceof(File).nullable().refine((e) => e instanceof File, {
  message: "shared.fileErrors.required"
}).refine(
  (e) => !e || !Vt(e.type) || e.size <= Fe(e.type),
  { message: "shared.fileErrors.tooLarge" }
), Cr = { ar: je, en: Xt };
function X() {
  return Cr[er.language] ?? je;
}
function Zn(e) {
  return B(e, "EEEE - dd/MM/yyyy", { locale: X() });
}
function Xn(e) {
  return B(e, "h:mm a", { locale: X() });
}
function ea(e) {
  return B(e, "EEEE - dd/MM/yyyy - h:mm a", { locale: X() });
}
function ta(e) {
  return e?.birthDate ? Rt(/* @__PURE__ */ new Date(), e.birthDate) : void 0;
}
export {
  Gn as AcceptTermsDialog,
  Zr as AwaitingSignatureBanner,
  Q as BACKEND_BASE_URL,
  Xr as BooleanLabel,
  Dn as CalendarIcon,
  Rn as ClockHistoryIcon,
  en as ConfirmDialog,
  tn as ContractPageSkeleton,
  ir as CounterField,
  rn as DateField,
  ln as DownloadGeneratedFile,
  dn as DownloadStoredFile,
  un as EmailInput,
  mn as EmptySection,
  pn as EquipmentListField,
  hn as ExpandableCheckbox,
  gn as FieldMessage,
  wn as FormMessage,
  An as HomeCard,
  Cn as ImageField,
  Tn as IncompleteProfileBanner,
  wr as InlineStep,
  In as InlineSteps,
  Ln as Loading,
  Pn as LocationLink,
  Fn as MultiSelect,
  On as PageContainer,
  yr as PasswordInput,
  jn as PendingDocumentsBanner,
  _n as PendingVerificationBanner,
  Nr as PhoneInput,
  qn as PriceField,
  Mn as RejectedAccountBanner,
  Vn as ScheduleHourRange,
  Wn as SearchInput,
  Bn as ServiceBadge,
  Hn as SignatureStatusCard,
  $n as SigningEmailNotice,
  Kn as SuccessIcon,
  Yn as TableRowSort,
  G as TheButton,
  Jn as UploadField,
  sn as ViewGeneratedFile,
  cn as ViewStoredFile,
  bn as apiErrorToMessage,
  L as client,
  Un as createMutationErrorHandler,
  cr as downloadGeneratedFile,
  ur as errorToFormIssue,
  Qn as fileField,
  vn as firebaseApp,
  Zn as formatDate,
  ea as formatDateTime,
  Xn as formatTime,
  zn as getCurrentCountry,
  yn as getSubject,
  mr as logout,
  kn as notifyPasswordChanged,
  gr as publicFileUrl,
  En as resetPasswordViaEmail,
  Jr as sharedAr,
  Qr as sharedEn,
  xn as signInEmail,
  Sn as signUpEmail,
  fn as sumEquipmentQuantities,
  ta as toAge,
  fr as uploadFile,
  an as useAction,
  on as useActionState,
  nn as useData,
  Nn as useSubject,
  dr as viewGeneratedFile
};
//# sourceMappingURL=index.js.map
